import { render, staticRenderFns } from "./ProcedureType.vue?vue&type=template&id=2867a389&scoped=true"
import script from "./ProcedureType.vue?vue&type=script&lang=js"
export * from "./ProcedureType.vue?vue&type=script&lang=js"
import style0 from "./ProcedureType.vue?vue&type=style&index=0&id=2867a389&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2867a389",
  null
  
)

export default component.exports